{
  "nickname": "ชื่อเล่น",
  "nicknameUpdated": "ตั้งชื่อเล่นสำเร็จ",
  "nicknameUpdateFailed": "ตั้งชื่อเล่นไม่สำเร็จ",
  "nicknameHint": "ใช้ตัวอักษรหรือตัวเลขของภาษาใดก็ได้ ห้ามมีอักขระพิเศษ และมีความยาวไม่เกิน 30 อักขระ",
  "save": "บันทึก",
  "changeLoginPassword": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
  "changeLoginPasswordSuccess": "เปลี่ยนรหัสผ่านเข้าสู่ระบบสำเร็จ",
  "changeLoginPasswordFailed": "เปลี่ยนรหัสผ่านเข้าสู่ระบบไม่สำเร็จ",
  "oldPassword": "รหัสผ่านเดิม",
  "oldPasswordPlaceholder": "กรอกรหัสผ่านเดิม",
  "setTransactionPassword": "ตั้งรหัสผ่านสำหรับการทำรายการ",
  "changeTransactionPassword": "เปลี่ยนรหัสผ่านสำหรับการทำรายการ",
  "newTransactionPassword": "รหัสผ่านสำหรับการทำรายการใหม่",
  "confirmTransactionPassword": "ยืนยันรหัสผ่านสำหรับการทำรายการ",
  "transactionPasswordSetSuccess": "ตั้งรหัสผ่านสำหรับการทำรายการสำเร็จ",
  "transactionPasswordChangedSuccess": "เปลี่ยนรหัสผ่านสำหรับการทำรายการสำเร็จ",
  "transactionPasswordSetFailed": "ตั้งรหัสผ่านสำหรับการทำรายการไม่สำเร็จ",
  "transactionPasswordChangedFailed": "เปลี่ยนรหัสผ่านสำหรับการทำรายการไม่สำเร็จ",
  "transactionPasswordSetFailedWithCode": "ตั้งรหัสผ่านสำหรับการทำรายการไม่สำเร็จ: {{code}}"
}
